import { useQueryClient } from '@tanstack/react-query';
import { Consent } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getProfileQueryKey } from 'features/users/queries';
import { acceptConsents } from '../../services';

export const useAcceptConsentsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<Consent[], { consentIds: string[] }>({
    async mutationFn({ consentIds }) {
      const response = await acceptConsents({ consent: { consent_ids: consentIds } });

      return response.data.map((consent) => new Consent(consent));
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
